












import Vue from 'vue';

export default Vue.extend({
  name: 'icon',
  props: ['icon'],
  methods: {
    // icon關鍵字偵測，針對class
    checkIcon(icon: string) {
      // icon有值時才觸發
      if (icon) {
        // 宣告字串
        const string = icon.toLowerCase();
        // 開始尋找
        const fa = string.indexOf('fa-');
        // 只要其中一值符合fontAwesome規範，則以fa方式印出icon
        // 反之class轉為material
        if (fa > -1) {
          return icon;
        }
        return `material-icons ${icon}`;
      }
      return '';
    },
  },
  computed: {
    // icon關鍵字偵測，針對後方雙括弧
    iconText(): string {
      const { icon } = this;
      if (icon) {
        // 再次宣告字串
        const string = icon.toLowerCase();
        // 開始尋找
        const fa = string.indexOf('fa-');
        // 只有在其值不符fontawesome時才列印material.io規範的icon
        if (fa === -1) {
          return icon;
        }
      }
      return '';
    },
  },
});
